import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type LicenseFeatureDTO = {
  key: string
  enabled: boolean
}

export type LicenseLimitDTO = {
  key: string
  value: number
}

export type LicenseLimitUsageDTO = {
  key: string
  current: number
  max: number
  remaining: number
  metricKey?: string
  usageDate?: string
}

export type LicenseStatusDTO = {
  enforcementEnabled: boolean
  capabilityEnforcementMode: string
  contractVersion: number
  licenseRevision: number
  modules: Array<{
    key: string
    includedByPlan: boolean
    enabled: boolean
    reason: string
    blockedBy?: string
  }>
  syncHealth: string
  syncSource?: string
  lastSuccessfulSyncAt?: string
  lastSyncAttemptAt?: string
  syncFailureCount: number
  lastSyncAttemptFailed: boolean
  customerId: string
  customerCode: string
  licenseId: string
  product: string
  plan: string
  status: string
  daysSinceExpiry: number
  checkedAt: string
  blockedCapabilities: string[]
  transitionTimeline: Array<{
    toStatus: string
    atUtc: string
  }>
  features: LicenseFeatureDTO[]
  limits: LicenseLimitDTO[]
  limitUsage: LicenseLimitUsageDTO[]
  guardCounters: Array<{
    mode: string
    capability: string
    decision: string
    reason: string
    count: number
  }>
}

export type LicenseSummaryDTO = {
  enforcementEnabled: boolean
  contractVersion: number
  licenseRevision: number
  modules: Array<{
    key: string
    includedByPlan: boolean
    enabled: boolean
    reason: string
    blockedBy?: string
  }>
  product: string
  plan: string
  status: string
  checkedAt: string
}

export type LicenseManualRefreshDTO = {
  status: string
  refreshTriggered: boolean
  error?: string
}

export const LicenseService = {
  getSummary: (): CancelablePromise<LicenseSummaryDTO> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/license/summary",
    })
  },

  getStatus: (): CancelablePromise<LicenseStatusDTO> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/license/status",
    })
  },

  triggerManualRefresh: (): CancelablePromise<LicenseManualRefreshDTO> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/license/status/refresh",
    })
  },
}
